// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36g1o","signatureBlock":"Footer_signatureBlock__2xFzg","signature":"Footer_signature__d1n41"};